import {OSS_BUCKET, URL_CONFIG} from '@/url_config';

const BASE_URL = URL_CONFIG.translation_url

export const getTranslationSvrUrl = (task_id, rootKey, file_hash) => {
    return `${BASE_URL}/process_file/translation/task_status?task_id=${task_id}`
}

export const commitFileTranslateTask = async(fileKey, rootKey, fileHash, project_id, saveBucket) => {

    const reqData = {
        key: fileKey,
        bucket: OSS_BUCKET,
        save_bucket: saveBucket,
        is_process_vectorgraph: true,
    }
    console.log("commitFileTranslateTask req", reqData)
    let res = {}
    try {
        const response = await fetch(`${BASE_URL}/process_file/translation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            console.warn('Network commitFileTranslateTask response was not ok');
            return res
        }

        const data = await response.json();
        if (!data) {
            console.warn('commitFileTranslateTask res empty');
            return res
        }
        if (data['error']) {
            console.warn('Error commitFileTranslateTask:', data['error']);
            return res
        }
        res = data

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    return res
};

export const commitBatchImgTranslateTask = async(fileKey, image_keys, fileHash, project_id, saveBucket) => {

    const reqData = {
        keys: image_keys,
        bucket: OSS_BUCKET,
        save_bucket: saveBucket,
    }
    console.log("commitFileTranslateTask req", reqData)
    let res = []
    try {
        const response = await fetch(`${BASE_URL}/process_file/batch_translation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData),
        });

        if (!response.ok) {
            console.warn('Network commitFileTranslateTask response was not ok');
            return res
        }

        const data = await response.json();
        if (!data) {
            console.warn('commitFileTranslateTask res empty');
            return res
        }
        if (data['error']) {
            console.warn('Error commitFileTranslateTask:', data['error']);
            return res
        }
        res = data

    } catch (error) {
        console.error('Error uploading file:', error);
    }
    return res
};
